import React from 'react';
import Navbar from '@/components/Navbar';
import OrganizerSidebar from '@/components/organizer/OrganizerSidebar';
import { useAuth } from '@/contexts/auth/AuthContext';
import { Navigate } from 'react-router-dom';
import { UserRoles } from '@/contexts/auth/enums';
import Footer from '@/components/Footer';

interface OrganizerLayoutProps {
  children: React.ReactNode;
}

const OrganizerLayout: React.FC<OrganizerLayoutProps> = ({ children }) => {
  const { user, isAuthenticated, isLoading } = useAuth();

  // Helper function to check if user is organizer
  const isOrganizer = () => {
    if (!user) return false;
    return user.roles.includes(UserRoles.ORGANIZER);
  };

  // Show loading state while checking authentication
  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-medihub-primary"></div>
      </div>
    );
  }

  // Check if user is authenticated and has organizer role
  if (!isAuthenticated || !isOrganizer()) {
    return <Navigate to="/" replace />;
  }

  return (
    <div className="flex min-h-screen flex-col">
      <Navbar />
      <div className="flex-grow container mx-auto py-6 px-4">
        {children}
      </div>
      <Footer />
    </div>
  );
};

export default OrganizerLayout;
